<template>
  <div>
    <el-dialog v-model="showLogin" :close-on-click-modal="false" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">登录后体验更多课程</div>
        <div class="close_icon cursor_pointer">
          <el-icon :size="24" @click="closePopup">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="login_type flex Flexjustify">
          <div class="flex flexcolumn cursor_pointer" :class="loginType == 1 ? 'select_type' : ''"
            @click="changeLoginType(1)">
            手机登录
            <el-image class="line_icon" :src="imgPath('active_line.png')" v-if="loginType == 1"></el-image>
          </div>
          <div class="flex flexcolumn password_type cursor_pointer" :class="loginType != 1 ? 'select_type' : ''"
            @click="changeLoginType(2)">
            密码登录
            <el-image class="line_icon" :src="imgPath('active_line.png')" v-if="loginType != 1"></el-image>
          </div>
        </div>
        <div class="phone_input" v-if="loginType == 1">
          <el-input v-model="loginInfo.phone" @input="(e) => checkNumber(e, 'phone')"
            style="max-width: 600px; height: 46px; border-radius: 10px" placeholder="请输入手机号">
            <template #append>
              <div class="code_get cursor_pointer" @click="getCode" :style="[getActiveColor()]">
                {{ textCode }}
              </div>
            </template>
          </el-input>
        </div>
        <div class="phone_input code_input" v-if="loginType == 1">
          <el-input v-model="loginInfo.verificationCode" @input="(e) => checkNumber(e, 'verificationCode')"
            style="max-width: 600px; height: 46px; border-radius: 10px" placeholder="请输入验证码" @keyup.enter="login(3)">
          </el-input>
        </div>
        <div class="phone_input account_input" v-if="loginType == 2">
          <el-input v-model="loginInfo.account" @input="(e) => checkNumber(e, 'account')"
            style="max-width: 600px; height: 46px" placeholder="请输入账号">
            <template #prepend>
              <div>账号</div>
            </template>
          </el-input>
        </div>
        <div class="phone_input code_input account_input" v-if="loginType == 2">
          <el-input v-model="loginInfo.password" @input="checkChinese" :type="isShowPassword ? 'text' : 'password'"
            style="max-width: 600px; height: 46px" placeholder="请输入密码" @keyup.enter="loginByPwd">
            <template #prepend>
              <div>密码</div>
            </template>
            <template #append>
              <div class="code_get flex Flexalign">
                <el-image class="eyes_icon cursor_pointer" :src="imgPath('eyes_open.png')"
                  style="width: 24px; height: 24px" v-if="isShowPassword" @click="hidePassword(false)"></el-image>
                <el-image class="eyes_icon cursor_pointer" :src="imgPath('eyes_closed.png')"
                  style="width: 24px; height: 24px" v-if="!isShowPassword" @click="hidePassword(true)"></el-image>
                <div class="fotget_password cursor_pointer" @click="forgetPassword">忘记密码?</div>
              </div>
            </template>
          </el-input>
        </div>
        <div class="login_attention">
          未注册过冠军高考专家辅导课的手机号，我们将自动帮你注册账号
          登录或完成注册即代表你同意
          <span class="active_text cursor_pointer" @click="openAgreement('user_login_agreement')">用户协议</span>
          和
          <span class="active_text cursor_pointer" @click="openAgreement('user_privacy_agreement')">隐私政策</span>
        </div>
        <div class="btn_box">
          <div class="flex Flexjustify btn btn_login cursor_pointer" v-if="loginType == 1" @click="login(3)">
            登录/注册
          </div>
          <div class="flex FlexBetween" v-if="loginType != 1">
            <!-- <div class="btn btn_small">注册</div> -->
            <div class="btn btn_login cursor_pointer" @click="loginByPwd">登录</div>
          </div>
        </div>
        <div class="other_text">其他方式登录</div>
        <div class="other_login flex FlexEvenly">
          <div class="flex Flexalign">
            <el-image class="weixin_icon" :src="imgPath('weixin_icon.png')"></el-image>
            <div class="weixin_text">微信登录</div>
          </div>
          <!-- <div class="flex Flexalign">
            <el-image class="weixin_icon" :src="imgPath('weibo_icon.png')"></el-image>
            <div class="weixin_text">微博登录</div>
          </div> -->
          <div class="flex Flexalign">
            <el-image class="weixin_icon" :src="imgPath('qq_icon.png')"></el-image>
            <div class="weixin_text">QQ登录</div>
          </div>
        </div>
        <div class="empty_bottom"></div>
      </div>
    </el-dialog>
    <agreement ref="agreement"></agreement>
  </div>
</template>

<script>
import agreement from "./agreement.vue";
export default {
  name: "GjkcH5Login",
  components: {
    agreement,
  },

  data() {
    return {
      showLogin: false,
      isShowPassword: false,
      loginType: 1,
      loginInfo: {
        phone: "",
        verificationCode: "",
        account: "",
        password: "",
      },
      textCode: "获取验证码",
      disabled: false,
    };
  },

  mounted() { },

  methods: {
    forgetPassword() {
      this.href("/passwordUpdate");
    },
    checkNumber(value, type) {
      this.loginInfo[type] = value.replace(/[^0-9]/g, ""); // 移除非数字字符
    },
    checkChinese(value) {
      // 允许字母、数字和常见符号：@ # $ % & * _ - + = ! ? .
      this.loginInfo.password = value.replace(/[^a-zA-Z0-9@#$%&*_\-+=!?.]/g, "");
    },
    closePopup() {
      this.showLogin = false;
      this.$store.commit('setShowLogin', false);
    },
    // 协议弹窗
    openAgreement(type) {
      this.$refs.agreement.agreementShow = true;
      this.$refs.agreement.type = type;
      this.$refs.agreement.getAgreement();
    },
    // 切换登录方式
    changeLoginType(type) {
      this.loginType = type;
    },
    // 获取验证码
    getCode() {
      if (this.$Tools.empty(this.loginInfo.phone)) {
        this.$Dialog.toast("手机号不能为空", { type: "error" });
        return;
      }
      if (!/^1[345678]\d{9}$/.test(this.loginInfo.phone)) {
        this.$Dialog.toast("请输入正确的手机号", { type: "error" });
        return;
      }
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.textCode = "重新发送 " + n + "s";
      this.$Api.login.getCode({ phone: this.loginInfo.phone }).then((res) => {
        if (res.data.code == 200) {
          this.$Dialog.toast("验证码已发送");
          const run = setInterval(() => {
            n = n - 1;
            if (n < 0) {
              clearInterval(run);
            }
            this.textCode = "重新发送 " + n + "s";
            if (this.textCode < "重新发送 " + 0 + "s") {
              this.disabled = false;
              this.textCode = "重新获取";
            }
          }, 1000);
        }
      });
    },
    // 登录
    login(type) {
      if (this.loginType == 1) {
        let params = {};
        if (this.$Tools.empty(this.loginInfo.verificationCode)) {
          this.$Dialog.toast("验证码不能为空", { type: "error" });
          return;
        }
        params.phone = this.loginInfo.phone;
        params.verificationCode = this.loginInfo.verificationCode;
        params.type = type;
        params.terminal = 5; // 0-未知 1-APP 2-微信小程序 3-H5 4-支付宝小程序 5-PC
        this.$Api.login
          .login(params)
          .then((res) => {
            this.$store.commit("setToken", res.data.data.token);
            this.$Api.login.getUserInfo().then((response) => {
              this.$store.commit("setUserInfo", response.data.data);
              this.$Dialog.toast("登录成功");
              this.loginInfo = {
                phone: "",
                verificationCode: "",
                account: "",
                password: "",
              };
              this.$emit("refreshPage");
              this.$store.commit("setShowLogin", false);
              setTimeout(() => {
                this.closePopup();
              }, 1000);
            });
          })
          .catch(() => {});
      }
    },
    // 登录(密码登录)
    loginByPwd() {
      let params = {};
      if (this.$Tools.empty(this.loginInfo.account)) {
        this.$Dialog.toast("账号不能为空", { type: "error" });
        return;
      } else if (this.$Tools.empty(this.loginInfo.password)) {
        this.$Dialog.toast("密码不能为空", { type: "error" });
        return;
      }
      params.phone = this.loginInfo.account;
      params.password = this.loginInfo.password;
      this.$Api.login
        .loginByPwd(params)
        .then((res) => {
          this.$store.commit("setToken", res.data.data.token);
          this.$Api.login.getUserInfo().then((response) => {
            this.$store.commit("setUserInfo", response.data.data);
            this.$Dialog.toast("登录成功");
            this.loginInfo = {
              phone: "",
              verificationCode: "",
              account: "",
              password: "",
            };
            this.$emit("refreshPage");
            this.$store.commit("setShowLogin", false);
            setTimeout(() => {
              this.closePopup();
            }, 1000);
          });
        })
        .catch(() => {});
    },
    getActiveColor() {
      if (this.loginInfo.phone) {
        return {
          color: "#13d6aa",
        };
      }
    },
    // 显示/隐藏密码
    hidePassword(flag) {
      this.isShowPassword = flag;
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 20px 20px 10px 10px;
  padding: 0;
  width: 460px;
}

:deep(.el-dialog__header) {
  position: relative;
}

.header {
  height: 105px;
  text-align: center;
  background-image: url(../../assets/img/login_top_bg.png);
  background-size: 100% 100%;
  font-weight: bold;
  font-size: 26px;
  color: #000000;
  line-height: 105px;
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
}

.dialog_content {
  text-align: center;

  .login_type {
    font-weight: 400;
    font-size: 20px;
    color: #666666;

    .select_type {
      font-weight: bold;
      font-size: 20px;
      color: #000000;
    }

    .password_type {
      margin-left: 40px;
    }

    .line_icon {
      width: 85px;
      height: 6px;
      margin-top: -5px;
    }
  }

  .phone_input {
    margin: 30px 25px 20px;

    :deep(.el-input-group__append) {
      background: #fff;
      //   padding: 6px 10px;
      box-sizing: border-box;
    }

    :deep(.el-input-group__prepend) {
      background: #fff;
      border-right: none;
      font-size: 16px;
      color: #212121;
    }

    :deep(.el-input-group--append>.el-input__wrapper) {
      border-radius: 10px 0 0 10px;
    }

    :deep(.el-input-group__append) {
      border-radius: 0 10px 10px 0;
    }

    :deep(.el-input__wrapper) {
      border-radius: 10px;
    }

    .code_get {
      color: #c9ccd0;
      width: 100px;
    }

    .fotget_password {
      margin-left: 6px;
      font-size: 16px;
      color: #13d6aa;
    }
  }

  .account_input {
    :deep(.el-input__wrapper) {
      border-radius: 0;
    }

    :deep(.el-input-group--append>.el-input__wrapper) {
      border-radius: 0;
    }
  }

  .code_input {
    margin: 0 25px;
  }

  .login_attention {
    margin: 20px 25px;
    text-align: start;
    font-size: 14px;
    color: #c9ccd0;
    line-height: 26px;

    .active_text {
      color: RGBA(19, 214, 170, 1);
    }
  }

  .btn_box {
    margin: 0 25px;

    .btn_login {
      background: linear-gradient(90deg, #00d5c2, #00d498);
      color: #fff;
    }

    .btn_small {
      width: 47%;
    }
  }

  .btn {
    margin: 0 auto;
    width: 240px;
    height: 42px;
    border-radius: 10px;
    line-height: 42px;
    font-size: 18px;
    color: #18191c;
    border: 1px solid #dfe1e3;
  }

  .other_text {
    margin-top: 30px;
    font-size: 14px;
    color: #666666;
  }

  .other_login {
    font-size: 16px;
    color: #9499a0;
    margin: 20px 25px 0;

    .weixin_icon {
      width: 30px;
      height: 30px;
    }

    .weixin_text {
      margin-left: 10px;
    }
  }

  .empty_bottom {
    width: 100%;
    height: 20px;
  }
}
</style>
